import { settingsApiRequest } from '../../screens/settings/settingsApi';

const handler = async (mediaGuide, { rejectWithValue }) => {
  try {
    const data = await settingsApiRequest({
      method: 'POST',
      path: '/settings/media-guide',
      body: mediaGuide, // { resource_name, name, description, link }
    });
    return { mediaGuide: data };
  } catch (error) {
    console.error('services.mediaguides.createMediaGuide@handler', error);
    return rejectWithValue({ status: error.status, message: error.message });
  }
};

const pending = (state) => ({ ...state, creating: true });
const fulfilled = (state, action) => ({
  ...state,
  creating: false,
  lists: [...state.lists, action.payload.mediaGuide],
});
const rejected = (state) => ({ ...state, creating: false });

export default { handler, pending, fulfilled, rejected };
